var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-3 mt-4"},[_c('v-subheader',{staticClass:"text-caption"},[_vm._v("授权")]),_c('ModifyPass'),_c('ClearData'),_c('Logout'),_c('v-subheader',{staticClass:"text-caption"},[_vm._v("已占用存储空间"+_vm._s(_vm.getDataSize))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }